import type { IconSvgObject } from './types';

const Wrench02Icon: IconSvgObject = [
  ["path", { d: "M15 11.5V19.1652C15 20.7308 13.6569 22 12 22C10.3431 22 9 20.7308 9 19.1652V11.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0063 18.999L12 19.0054", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "1" }],
  ["path", { d: "M13.7678 12.7322L17.2322 9.26777C18.2085 8.29146 18.2085 6.70854 17.2322 5.73223L13.5 2V6.5C13.5 7.32843 12.8284 8 12 8C11.1716 8 10.5 7.32843 10.5 6.5V2L6.76777 5.73223C5.79146 6.70854 5.79145 8.29145 6.76777 9.26777L10.2322 12.7322C11.2085 13.7085 12.7915 13.7085 13.7678 12.7322Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Wrench02Icon;
